<!--@Version 1.3.0-->
<footer data-testid="footer" [class.change-color]="(TRANSLATE_PATH.FOOTER_CHANGE_COLOR | translateDesign) == 'false'" #footerBar [ngClass]="'fixed-' + (TRANSLATE_PATH.FOOTER_FIXED_VARIANT | translateDesign)"  (click)="onMouseEnter(footerBar)"
  (mouseleave)="onMouseLeave(footerBar)">
   <div [ngClass]="(TRANSLATE_PATH.FOOTER_SHADOW_ENABLED | translateDesign)  == 'true' ? 'shadow-' + (TRANSLATE_PATH.FOOTER_SHADOW_VARIANT | translateDesign) : ''" data-testid="shadow">
      @if ((TRANSLATE_PATH.FOOTER_TOP_ENABLED | translateDesign) != 'false') {
         <mat-toolbar color="footer-top" data-testid="footer-top">
            <div class="page-wrapper">
               @if ((TRANSLATE_PATH.FOOTER_TOP_TEXT | translateDesign) != 'false') {
                  <ul>
                     <li>
                        <span class="mat-h4" data-testid="copyright">{{TRANSLATE_PATH.FOOTER_COPYRIGHT | translateDesign }} {{TRANSLATE_PATH.BANKNAME| translateDesign }}, {{ todayTime | date: 'YYYY' }}</span>
                     </li>
                     <li>
                        @for (item of (TRANSLATE_PATH.FOOTER_LIST | translateDesign | linkList); track item; let isLast = $last) {
                           <a del="noopener noreferer" [attr.href]="item.url" [attr.target]="item.target ?? '_self'">
                              <span class="mat-h4" >{{item.name}}</span>
                           </a>
                           @if (!isLast) {
                              <span [innerHTML]="TRANSLATE_PATH.FOOTER_LIST_SEP | translateDesign" data-testid="seperator"></span>
                           }
                        }
                     </li>
                  </ul>
               }
            </div>
         </mat-toolbar>
       }
      @if ((TRANSLATE_PATH.FOOTER_BOTTOM_ENABLED | translateDesign) == 'true') {
         <mat-toolbar color="footer-bottom" class="footer-bottom" data-testid="footer-bottom">
            <div class="page-wrapper row">
               <ng-content select="[leftSide]"></ng-content>
               @if ((TRANSLATE_PATH.FOOTER_BOTTOM_ENABLED_TEXT | translateDesign) == 'true') {
                  <span class="mat-h6" [attr.color]="(TRANSLATE_PATH.FOOTER_BOTTOM_COLOR | translateDesign)" class="slogan center" data-width="100%" [innerHTML]="TRANSLATE_PATH.FOOTER_BOTTOM_TEXT | translateDesign" ></span>
               }
               <ng-content select="[rightSide]"></ng-content>
            </div>
         </mat-toolbar>
      }
   </div>
</footer>